/**
 * The "Try:" buttons.
 *
 * Every tool has them and every tool does the same thing with them, so the
 * loop lives here rather than once per tool. Which sentences are offered
 * stays in the templates: what best shows a tool off is an editorial question,
 * and the person writing the page copy is the one who should answer it.
 */

/**
 * Wire every example button under a container to fill the input.
 */
export function wireExamples(
  container: HTMLElement,
  onPick: (text: string) => void,
): void {
  for (const button of container.querySelectorAll<HTMLButtonElement>(
    "[data-cb-example]",
  )) {
    button.addEventListener("click", () => {
      onPick(button.dataset["cbExample"] ?? "");
    });
  }
}
